<template>
	<div class="watchlist-teaser">
		{{ watchlist.name }}
	</div>
</template>

<script>
	export default {
		name: "WatchlistTeaser",
		props: ['watchlist']
	}
</script>

<style scoped>
	.watchlist-teaser {
		cursor: pointer;
		color: var(--q-color-primary);
	}
</style>